module.exports = "<canvas #terrain width=\"50\" height=\"50\"></canvas><canvas #objects width=\"50\" height=\"50\"></canvas>";